<div #templateEditorPreviewParent id="template-editor-preview-parent" class="preview-parent embed-responsive">
  <iframe #templateEditorPreview id="template-editor-preview"
    class="embed-responsive-item"
    scrolling="no"
    [src]="editorPreviewUrl" (load)="onLoad($event)">
  </iframe>
</div>
